export default {
  getList: (specifiedKey) => ['docker-image-list-' + specifiedKey],
  getDetail: (specifiedKey) => ['docker-image-detail-' + specifiedKey],
  getAvailableName: (specifiedKey) => [
    'docker-repositories-available-' + specifiedKey,
  ],
};
